// 🚀 FINAL VERSION — pills turn white on hover / drag / tap
// * Hover (desktop), touch-hold (mobile), or drag makes pill background #ffffff
// * Reverts to green when inactive
// * Keeps all previous mobile hitbox & sizing logic intact

function startMatterCanvas() {
  const canvas = document.getElementById('matter-canvas');
  if (!canvas) return;

  const { Engine, Render, Runner, World, Bodies, Mouse, MouseConstraint, Events, Body, Bounds } = Matter;
  const engine = Engine.create();
  const world  = engine.world;

  const DPR      = window.devicePixelRatio || 1;
  const isMobile = window.innerWidth <= 768;
  const PARENT   = canvas.parentElement;
  const WIDTH    = PARENT.clientWidth;
  const HEIGHT   = PARENT.clientHeight;

  const fontFamily = getComputedStyle(document.documentElement).getPropertyValue('--Serenity-light').trim() || 'sans-serif';
  const baseFontPx = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--h6').trim().replace('px', '')) || 16;
  const FONT_SIZE  = isMobile ? Math.round(baseFontPx * 0.9) : baseFontPx;
  const FONT       = `600 ${FONT_SIZE}px ${fontFamily}`;
  const LINE_H     = FONT_SIZE * 1;
  const PAD_X      = isMobile ? FONT_SIZE * 4 : FONT_SIZE * 5;
  const PAD_Y      = isMobile ? 10 : 15;
  const CIRCLE_PAD = 12;

  canvas.width  = WIDTH  * DPR;
  canvas.height = HEIGHT * DPR;
  canvas.style.width  = `${WIDTH}px`;
  canvas.style.height = `${HEIGHT}px`;
  const ctx = canvas.getContext('2d');
  ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  ctx.font = FONT;

  const render = Render.create({
    canvas,
    engine,
    options: { width: WIDTH, height: HEIGHT, pixelRatio: DPR, background: 'transparent', wireframes: false }
  });

  // ─────────────────────────────── DATA FROM SECTION SETTINGS
  let pillTexts = [], circleInfos = [];
  try {
    const settings = JSON.parse(canvas.getAttribute('data-circle-images') || '{}');
    for (let i = 0; i < 9; i++) {
      const key = i === 0 ? 'text_bars' : `text_bars_${i+1}`;
      if (settings[key]) pillTexts.push(settings[key]);
    }
    const desktopSizes = [52, 43, 35, 44];
    const mobileSizes  = [32, 27, 22, 38];
    const selected     = isMobile ? mobileSizes : desktopSizes;
    for (let i = 1; i <= 4; i++) {
      const imgKey = `circle_image_${i}`;
      if (settings[imgKey]) circleInfos.push({ src: settings[imgKey], size: selected[i-1], url: settings[`circle_url_${i}`] || null });
    }
  } catch(e) { console.warn('JSON parse error'); }
  if (!pillTexts.length) pillTexts = ['Conversion Rate Optimization','Shopify Store Design'];

  // ─────────────────────────────── HELPERS
  function measure(text) {
    const words = text.split(' ');
    let line = '', lines=[], max=0;
    for(const w of words){ const test=line+w+' '; const wid=ctx.measureText(test).width; if(wid>9999){lines.push(line.trim()); line=w+' ';}else{line=test;} }
    lines.push(line.trim()); lines.forEach(l=>max=Math.max(max,ctx.measureText(l).width)); return {lines,width:max};
  }

  const pills=[], circles=[];
  pillTexts.forEach(txt=>{
    const {lines,width}=measure(txt);
    const totalW=width+PAD_X*2, totalH=Math.max(lines.length*LINE_H,LINE_H)+PAD_Y*1.5;
    const body=Bodies.rectangle(Math.random()*(WIDTH-totalW)+totalW/2,Math.random()*(HEIGHT-totalH)+totalH/2,totalW,totalH,{ chamfer:{radius:15}, restitution:0.8, friction:0.1, frictionAir:0.05, render:{fillStyle:'transparent',strokeStyle:'transparent'} });
    Object.assign(body,{lines,totalW,totalH,text:txt,isPill:true,isHovered:false,isActive:false});
    pills.push(body);
  });

  circleInfos.forEach(info=>{
    const r=info.size/2+CIRCLE_PAD;
    const body=Bodies.circle(Math.random()*(WIDTH-r*2)+r,Math.random()*(HEIGHT-r*2)+r,r,{restitution:0.9,friction:0.05,render:{fillStyle:'transparent',strokeStyle:'transparent'}});
    const img=new Image(); img.src=info.src; Object.assign(body,{img,imgSize:info.size,link:info.url}); circles.push(body);
  });

  // walls
  World.add(world,[...pills,...circles,Bodies.rectangle(WIDTH/2,-60,WIDTH,120,{isStatic:true}),Bodies.rectangle(WIDTH/2,HEIGHT+60,WIDTH,120,{isStatic:true}),Bodies.rectangle(-60,HEIGHT/2,120,HEIGHT,{isStatic:true}),Bodies.rectangle(WIDTH+60,HEIGHT/2,120,HEIGHT,{isStatic:true})]);

  // ─────────────────────────────── INTERACTION
  const mouse=Mouse.create(canvas); mouse.pixelRatio=DPR;
  const mouseConstraint=MouseConstraint.create(engine,{mouse,constraint:{stiffness:0.2,render:{visible:false}}}); World.add(world,mouseConstraint); render.mouse=mouse;

  // bigger hitbox on mobile
  mouseConstraint._getBodyAt=(bodies,pos)=>{const ex=isMobile?25:0;for(const b of bodies){const bd=Bounds.create(b.vertices);bd.min.x-=ex;bd.min.y-=ex;bd.max.x+=ex;bd.max.y+=ex;if(Bounds.contains(bd,pos))return b;}return null;};

  // hover detection desktop
  Events.on(mouseConstraint,'mousemove',e=>{const pos=e.mouse.position; pills.forEach(p=>{const {totalW,totalH}=p; p.isHovered= pos.x>=p.position.x-totalW/2 && pos.x<=p.position.x+totalW/2 && pos.y>=p.position.y-totalH/2 && pos.y<=p.position.y+totalH/2;});});

  // drag state
  let downPos=null,activeBody=null;
  Events.on(mouseConstraint,'mousedown',e=>{downPos=e.mouse.mousedownPosition;});
  Events.on(mouseConstraint,'startdrag',e=>{activeBody=e.body; if(activeBody?.isPill) activeBody.isActive=true;});
  Events.on(mouseConstraint,'enddrag',()=>{if(activeBody?.isPill) activeBody.isActive=false; activeBody=null;});

  Events.on(mouseConstraint,'mouseup',e=>{const up=e.mouse.absolute;moved=downPos&&(Math.abs(up.x-downPos.x)>5||Math.abs(up.y-downPos.y)>5); if(!moved&&!activeBody){[...pills,...circles].forEach(b=>{if(Bounds.contains(b.bounds,up)&&b.link) window.open(b.link,'_blank');});} downPos=null;});

  // containment
  Events.on(engine,'afterUpdate',()=>{[...pills,...circles].forEach(b=>{const w=b.bounds.max.x-b.bounds.min.x,h=b.bounds.max.y-b.bounds.min.y;let{x,y}=b.position;x=Math.max(w/2,Math.min(WIDTH-w/2,x));y=Math.max(h/2,Math.min(HEIGHT-h/2,y));Body.setPosition(b,{x,y});});});

  // ─────────────────────────────── CUSTOM RENDER
  Events.on(render,'afterRender',()=>{
    const ctx=render.context; ctx.font=FONT; ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.lineWidth=1.5;
    pills.forEach(p=>{ctx.save();ctx.translate(p.position.x,p.position.y);ctx.rotate(p.angle);ctx.beginPath();ctx.roundRect(-p.totalW/2,-p.totalH/2,p.totalW,p.totalH,60);ctx.fillStyle=(p.isHovered||p.isActive)?'#ffffff':'#B7EE73';ctx.fill();ctx.strokeStyle='#000';ctx.stroke();ctx.fillStyle='#000';p.lines.forEach((l,i)=>ctx.fillText(l,0,-(p.lines.length-1)*LINE_H/2+i*LINE_H));ctx.restore();});
    circles.forEach(c=>{ctx.save();ctx.translate(c.position.x,c.position.y);ctx.rotate(c.angle);ctx.beginPath();ctx.arc(0,0,c.circleRadius,0,Math.PI*2);ctx.fillStyle='#B7EE73';ctx.fill();ctx.strokeStyle='#000';ctx.stroke(); if(c.img?.complete) ctx.drawImage(c.img,-c.imgSize/2,-c.imgSize/2,c.imgSize,c.imgSize); ctx.restore();});
  });

  Runner.run(Runner.create(),engine);
  Render.run(render);
}

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    trigger: '#matter-canvas',
    start: 'top 50%', // adjust if needed
    once: true,
    onEnter: () => {
      console.log('Running');
      startMatterCanvas();
    }
  });
});
